module.exports = __webpack_public_path__ + "static/media/worldfavor_wordmark_white.4932924e.svg";